export default "__VITE_ASSET__aaed7384__"